import {Component} from '@angular/core';
import { ConfigService } from '../../service/config.service';
import {AnalyticsTracker} from '../../utils/AnalyticsTracker';

@Component({
    selector: 'app-invest',
    templateUrl: './invest.component.html',
    styleUrls: ['./invest.component.css', './investor-home.component.css', '../../../assets/styles/new-styles.css']
})

export class InvestComponent {
    schemaData = `{
      "@id": "https://finzy.com/#organization",
      "@context": "http://schema.org",
      "@type": "Organization",
      "name": "finzy",
      "description": "A digital platform that connects borrowers looking for personal loans with Investors looking to invest in an asset class with risk optimised returns. Finzy makes P2P lending easy for lenders. Get the best investment opportunities with finzy.",
      "logo": "https://res.cloudinary.com/finzy/image/upload/v1534503733/finzy-logo-1x1_dyqago.png",
      "url": "https://finzy.com/invest",
      "telephone": "+91 9341 300 300",
      "legalName": "Bridge Fintech Solutions Private Limited",
      "foundingDate": "6 October 2016",
      "founders": [
        {
          "@type": "Person",
          "name": "Amit More"
        },
        {
          "@type": "Person",
          "name": "Abhinandan Sangam"
        },
        {
          "@type": "Person",
          "name": "Vishwas Dixit"
        }
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "118, 1st Floor, 80 Feet Road",
        "addressLocality": "Koramangala 7th Block",
        "addressRegion": "Bengaluru",
        "postalCode": "560095",
        "addressCountry": "India"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Support",
        "telephone": "[+91-9341-300-300]",
        "email": "support@finzy.com"
      },
      "sameAs": [
        "https://www.facebook.com/finzyindia",
        "https://www.linkedin.com/company/finzy",
        "https://www.instagram.com/finzyindia/",
        "https://twitter.com/finzyindia"
      ]
    }`;
    activeFinzyVersion: string;

    constructor(public analyticsTracker: AnalyticsTracker, private configService: ConfigService) {
      this.activeFinzyVersion = this.configService.getActiveFinzyVersion();
    }
}
